import { Inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'bringozTemperature'
})
export class BringozTemperaturePipe implements PipeTransform {

  private isImperial: boolean;
  private unit: string;

  constructor(@Inject('splitService') private splitService) {
    this.isImperial = this.splitService.isImperial();
    this.unit = this.splitService.getTemperatureUnit(true);
  }

  /**
   * Convert Celsius to display temperature based on site unit setting
   * @param celsius - Temperature in Celsius from server
   * @param showUnit - Whether to append unit symbol
   * @param defaultValue - Default value if undefined
   */
  transform(celsius: number | undefined, showUnit: boolean = true, defaultValue: string = '---'): string {
    if (celsius === undefined || celsius === null) {
      return defaultValue;
    }

    let displayValue: number;
    if (this.isImperial) {
      // Convert Celsius to Fahrenheit: (C × 9/5) + 32
      displayValue = (celsius * 9 / 5) + 32;
    } else {
      displayValue = celsius;
    }

    return `${displayValue.toFixed(1)}${showUnit ? ' ' + this.unit : ''}`;
  }
}

